import { render, staticRenderFns } from "./LockedPortalUsers.vue?vue&type=template&id=10c06e5b&"
import script from "./LockedPortalUsers.vue?vue&type=script&lang=js&"
export * from "./LockedPortalUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports